import { render, staticRenderFns } from "./empty-search.vue?vue&type=template&id=1ed6c395&"
import script from "./empty-search.vue?vue&type=script&lang=ts&"
export * from "./empty-search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports